import { limitCharacters, nativeShare } from "../modules/modules";
import logo from "../assets/logo.png";
export const AssetCard = ({ thumbnail, title, oldPrice, newPrice }) => {
    const oldNum = Number(oldPrice);
    const newNum = Number(newPrice);
    const hasPrices = Number.isFinite(oldNum) && Number.isFinite(newNum) && oldNum > 0;
    const discountPct = hasPrices ? ((newNum / oldNum) * 100).toFixed(0) : null;

    return (
        
        <article className="asset-card">
            <div className="asset-card__image-wrap">
                <img
                    className="asset-card__image"
                    src={thumbnail || logo}
                    alt={title || "Product image"}
                    loading="lazy"
                />
                {hasPrices && (
                    <span className="asset-card__badge">TZS {newNum.toLocaleString()}</span>
                )}
            </div>
            <div className="asset-card__body">
                <h2 className="asset-card__title">{limitCharacters(title, 10)}</h2>
                {discountPct && (
                    <p className="asset-card__description">
                        {`- ${discountPct}%`}
                    </p>
                )}
                {hasPrices && (
                    <div className="asset-card__footer">
                        <p className="asset-card__price">
                            <s>{oldNum.toLocaleString()} TZS</s>
                        </p>
                        <button
                            className="share-button asset-card__share-button"
                            aria-label="Share"
                            aria-haspopup="true"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                nativeShare(title, `${title} - ${newNum.toLocaleString()} TZS`, window.location.href);
                            }}
                            type="button"
                            title="Share"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="18" cy="5" r="3"></circle>
                                <circle cx="6" cy="12" r="3"></circle>
                                <circle cx="18" cy="19" r="3"></circle>
                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                            </svg>
                        </button>
                    </div>
                )}
            </div>
        </article>
    );
};